export default __webpack_public_path__ + "static/media/droplet-set-orange.0647e446.png";